// Service Worker — Désactivé complètement pour éviter les conflits de cache

export function register() {
  // Ne rien faire — service workers désactivés
  unregister();
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    // Désinscrire TOUS les service workers existants
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
      }
    }).catch(() => {});

    // Vider tous les caches
    if ('caches' in window) {
      caches.keys().then((keys) => {
        keys.forEach((key) => caches.delete(key));
      }).catch(() => {});
    }
  }
}

export function requestNotificationPermission() {
  // Désactivé
}
